import type { ActionTypes as Action } from 'actions/user/abTest'
import { Constants } from 'actions/user/abTest'
export const defaultState = ''
type State = string
export default (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case Constants.SET_AB_TEST:
      return action.payload || ''

    default:
      return state
  }
}